import actionConsts from './../constants/actions';
import store from './../store/store';

const startTutorial = () => (
    store.dispatch({
        type: actionConsts.START_TUTORIAL
    })
);

const stopTutorial = () => (
    store.dispatch({
        type: actionConsts.STOP_TUTORIAL
    })
);

const endTutorial = () => (
    store.dispatch({
        type: actionConsts.END_TUTORIAL
    })
);

const addStepsToTutorial = (steps, type) => {
    store.dispatch({
        type: actionConsts.ADD_TUTORIAL_STEPS,
        payload: {
            steps,
            type
        }
    });
}

const updateStepNumber = (id) => {
    store.dispatch({
        type: actionConsts.UPDATE_TUTORIAL_STEP,
        stepId: id
    });
}

const setEndTutorialPopup = (flag) => {
    store.dispatch({
        type: actionConsts.SET_END_TUTORIAL_POPUP_FLAG,
        payload: flag
    })
}

export {
    startTutorial,
    stopTutorial,
    endTutorial,
    addStepsToTutorial,
    updateStepNumber,
    setEndTutorialPopup
};


// WEBPACK FOOTER //
// /src/actions/tutorial.js